export interface IExistingRegistration {
    id: number,
    patientRegistrationDateTime: string,
    centerId: number,
    centerAlias: string
}